module.exports = __webpack_public_path__ + "img/folder.dcec8ec2.png";